import * as yup from 'yup'

export const schemaUser = (enableResponsible, isSupplier) => {
  return yup.object().shape({
    name: yup.string().required(),
    email: yup.string().email().required(),
    ...(!isSupplier && {
      departments: yup.array().of(
        yup.object().shape({
          id: yup.number().required('Selecione um departamento'),
          name: yup.string().required('Selecione um departamento'),
        }),
      ),
    }),
    ...(!enableResponsible && {
      profileId: yup.string().required(),
    }),
    ...(enableResponsible && {
      phone: yup.string().phone({ required: true }),
    }),
  })
}

export default schemaUser
